import React from 'react';
import '../css/Footer.css';
import { Link } from 'react-router-dom';

const Footer = () => {
  const publicUrl = process.env.PUBLIC_URL;

  return (
    <footer className="footer-container">
      <div className="footer-inner">
        <div className="footer-row">

          {/* Left Column: Our Team on top, Contact below */}
          <div className="footer-column left-buttons-column">
            <Link
              to="/team"
              className="footer-btn"
              aria-label="Go to Our Team page"
            >
              Our Team
            </Link>

            <Link
              to="/contact_form"
              className="footer-btn"
              aria-label="Go to Contact With Us page"
              style={{ marginTop: '15px' }}
            >
              Contact Us
            </Link>
          </div>

          {/* Right Column: Sponsors with clickable logos */}
          <div className="footer-column sponsors-column">
            <h4>Sponsors</h4>
            <div className="sponsor-logos">

              <a
                href="https://www.aau.edu.et/"
                target="_blank"
                rel="noopener noreferrer"
                className="sponsor"
              >
                <img
                  src={`${publicUrl}/images/aau.jpeg`}
                  alt="Addis Ababa University (AAU)"
                  className="sponsor-logo"
                />
                AAU
              </a>

              <a
                href="https://www.aastu.edu.et/"
                target="_blank"
                rel="noopener noreferrer"
                className="sponsor"
              >
                <img
                  src={`${publicUrl}/images/aastu.png`}
                  alt="Addis Ababa Science and Technology University (AASTU)"
                  className="sponsor-logo"
                />
                AASTU
              </a>

              <a
                href="https://www.betin.gov.et/"
                target="_blank"
                rel="noopener noreferrer"
                className="sponsor"
              >
                <img
                  src={`${publicUrl}/images/betin.png`}
                  alt="Ethiopian Biotechnology Institute (EBTI)"
                  className="sponsor-logo"
                />
                BETin
              </a>

            </div>
          </div>

        </div>
      </div>

      <div className="footer-bottom">
        &copy; {new Date().getFullYear()} Tef Platform. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;

